// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"aa09911a","342":"c1377138","516":"4c895737"}[chunkId] + ".chunk.js";
};